<div *ngIf="template">
  <form #templateForm="ngForm">
    <div class="form-row">
      <div class="form-group col-xs-9 col-sm-9 col-lg-9">
        <label for="name">Nome</label>
        <input class="form-control" type="text" id="name" name="name" [(ngModel)]="template.name" #name="ngModel" required minlength="3" maxlength="250" />
        <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger">
          <small>
            <div *ngIf="name.errors.required">Nome é obrigatório</div>
            <div *ngIf="name.errors.minlength">Nome deve ter no mínimo 3 caracteres</div>
            <div *ngIf="name.errors.maxlength">Nome deve ter no máximo 250 caracteres</div>
          </small>
        </div>
      </div>

      <div class="form-group col-xs-3 col-sm-3 col-lg-3">
        <label for="examGroup">Grupo</label>
        <select id="examGroup" class="form-control" name="examGroup" #examGroup="ngModel" [(ngModel)]="template.exam_group_id" required>
          <option *ngFor="let eg of examGroups" [value]="eg.id">{{eg.name}}</option>
        </select>
        <div *ngIf="examGroup.invalid && (examGroup.dirty || examGroup.touched)" class="text-danger">
          <small><div *ngIf="examGroup.errors.required">Grupo é obrigatório</div></small>
        </div>
      </div>

    </div>
    <div class="form-row">
      <div class="form-group col-xs-12 col-sm-12 col-lg-12">
        <label>Descrição</label>
        <input class="form-control" type="text" id="description" name="description" [(ngModel)]="template.description" #description="ngModel" required minlength="3" maxlength="250" />
        <div *ngIf="description.invalid && (description.dirty || description.touched)" class="text-danger">
          <small>
            <div *ngIf="description.errors.required">Descrição é obrigatória</div>
            <div *ngIf="description.errors.minlength">Descrição deve ter no mínimo 3 caracteres</div>
            <div *ngIf="description.errors.maxlength">Descrição deve ter no máximo 250 caracteres</div>
          </small>
        </div>
      </div>
    </div>
    <div class="float-right mt-3 mb-2">
      <button class="btn btn-secondary mr-1" (click)="cancel()">Cancelar</button>
      <button class="btn btn-primary mr-1" [disabled]="!templateForm.form.valid" (click)="save()">Salvar</button>
    </div>
  </form>
</div>
